import React, { useEffect, useState } from "react";
import styles from "./WalletOverview.module.sass";
import Wallet from "../../components/Wallet";
import { useTranslation } from "react-i18next";
import { fetchWallets } from "store/actions";
import { useDispatch } from "react-redux";
import AssetBalances from "./AssetBalances";
import WalletsTransactions from "./walletsTransactions";
import { fetchAvailableAssets, } from 'store/general/assets/actions'


const WalletOverview = () => {
  const dispatch = useDispatch();
  const [selectedAsset, setSelectedAsset] = useState(null);
  const loadWallets = () => {
    dispatch(fetchWallets());
  };
  useEffect(() => {
    loadWallets({});
    dispatch(fetchAvailableAssets())
  }, []);

  return (
    <Wallet>
      <div className={styles.list}>
        <div className={styles.item}>
          <div className={styles.head}></div>
          <div className={styles.body}>
            <AssetBalances
              setSelectedAsset={setSelectedAsset}
            />
            <WalletsTransactions
              selectedAsset={selectedAsset}
            />
          </div>
        </div>
      </div>
    </Wallet>
  );
};

export default WalletOverview;
